import { render } from "./servicesManage.vue?vue&type=template&id=f143c9d6&scoped=true"
import script from "./servicesManage.vue?vue&type=script&lang=js"
export * from "./servicesManage.vue?vue&type=script&lang=js"

import "./servicesManage.vue?vue&type=style&index=0&id=f143c9d6&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f143c9d6"]])

export default __exports__